import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import Autocomplete, { RenderOptionState } from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import style from './style.module.css';
import typ from 'design-v2/globals/typography.module.css';
import { ITagItem, ITagPanel } from './types';
import { InputAdornment } from '@material-ui/core';
import TagListItem from './TagListItem';
import SearchIcon from '@material-ui/icons/Search';
import TagChip from './TagChip';
import BCComponentWrapper from 'design-v2/common/BCComponentWrapper/BCComponentWrapper';

export * from './types';

const TagPanel = (props: ITagPanel) => {
  const { tags, groupCondition = null, handleTagChanged, containerStyle = null } = props;

  const [tagList, setTagList] = useState<ITagItem[]>(tags);
  const [selectedTags, setSelectedTags] = useState<ITagItem[]>([]);

  useEffect(() => {
    setTagList(tags);
    setSelectedTags(tags.filter((t: ITagItem) => t.selected));
  }, [tags]);

  const handleDelete = (tag: ITagItem) => {
    const tempTags = selectedTags.filter((t: ITagItem) => t.name !== tag.name);
    setSelectedTags(tempTags);
    handleTagChanged(tempTags);
  };

  const handleChange = (tags: ITagItem[]) => {
    setSelectedTags(tags);
    handleTagChanged(tags);
  };

  return (
    <BCComponentWrapper title={'Tags'} containerStyle={{ paddingBottom: '21px' }}>
      <div>
        <div>
          {selectedTags &&
            selectedTags.map((tag: ITagItem, index: number) => (
              <TagChip
                key={index.toString()}
                testId={index}
                tag={tag}
                handleDelete={() => handleDelete(tag)}
              />
            ))}
        </div>
        <div className={style.searchContainer}>
          <Autocomplete
            data-testid={'tag-auto-complete-id'}
            // open={true}
            multiple
            className={style.fullWidth}
            options={tagList}
            value={selectedTags}
            onChange={(e: any, newValue: ITagItem[]) => handleChange(newValue)}
            getOptionLabel={(option) => option.name}
            disableClearable
            disableCloseOnSelect
            ListboxProps={{
              className: style.tagSearchItem,
            }}
            renderOption={(option: ITagItem, state: RenderOptionState) => (
              <TagListItem tag={option} state={state} />
            )}
            renderInput={(params) => (
              <TextField
                data-testid={'tag-search-field-id'}
                {...params}
                variant="standard"
                placeholder="Search tag by name"
                className={style.fullWidth}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className={style.searchIcon} />
                    </InputAdornment>
                  ),
                  className: classNames({
                    [style.searchField]: true,
                    [typ.typSize2]: true,
                    [typ.typMed]: true,
                  }),
                }}
              />
            )}
            groupBy={(option: any) =>
              !!groupCondition
                ? option.tagtype._id !== groupCondition.detectTagTypeId
                  ? groupCondition.groupLables.notMatched
                  : groupCondition.groupLables.matched
                : null
            }
          />
        </div>
      </div>
    </BCComponentWrapper>
  );
};
export default TagPanel;
